var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import styled from "styled-components";
import { Input } from "@irati/ui/src/FormItem";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import Validation from "@irati/utils/validation";
var StyledInput = styled(Input)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var PROPERTY = "name";
export var schema = function (intl, required) {
    return Validation.string(required ? intl.formatMessage({ id: "platform.defaultValidation.required" }) : null);
};
var CompanyValuesHeader = /** @class */ (function (_super) {
    __extends(CompanyValuesHeader, _super);
    function CompanyValuesHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyValuesHeader.prototype.render = function () {
        var _a = this.props, companyValue = _a.companyValue, formatMessage = _a.formatMessage, intl = _a.intl, label = _a.label, onChange = _a.onChange, placeholder = _a.placeholder, required = _a.required, other = __rest(_a, ["companyValue", "formatMessage", "intl", "label", "onChange", "placeholder", "required"]);
        return (React.createElement(StyledInput, __assign({ id: id(PROPERTY, this.props), label: label || formatMessage({ id: "admin.companyValues.fields.header.label" }), name: PROPERTY, onBlur: function (value) { return onChange(PROPERTY, value ? value.trim() : null); }, onChange: function (value) { return onChange(PROPERTY, value); }, placeholder: placeholder || formatMessage({ id: "admin.companyValues.fields.header.placeholder" }), validation: schema(intl, required), value: companyValue[PROPERTY] }, other)));
    };
    CompanyValuesHeader.defaultProps = {
        id: "company-values",
        maxLength: 44,
        required: true
    };
    return CompanyValuesHeader;
}(Component));
export default injectIntl(CompanyValuesHeader);
var templateObject_1;
